import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DataRetentionPolicy, DataRetentionPolicyCreate, DataRetentionPolicyFilter } from '../data/dataRetentionPolicy';

export function createDataRetentionPolicyService(client: AxiosInstance) {
  return createCrudService<DataRetentionPolicy, DataRetentionPolicyCreate, DataRetentionPolicyFilter>(
    client,
    '/audit/DataRetentionPolicy',
    'id',
  );
}

export type DataRetentionPolicyService = CrudService<DataRetentionPolicy, DataRetentionPolicyCreate, DataRetentionPolicyFilter>;
